import React from "react";
import { Link, useLocation } from "react-router-dom";

import { tw } from "@careinfo/tailwind";
import CreateIcon from "../../../Icons/CreateIcon";
import UploadIcon from "../../../Icons/UploadIcon";

const SwitchTab = ({ id }) => {
  const location = useLocation();

  const tabs = [
    {
      id: "list",
      label: "Statement Preview",
      icon: <CreateIcon />,
      href: `/preview/${id}`,
    },
    {
      id: "document",
      label: "Documents",
      icon: <UploadIcon />,
      href: `/documents/${id}`,
    },
  ];

  return (
    <div className={tw`flex gap-4 my-4`}>
      {tabs.map((tab) => {
        const isActive = location.pathname === tab.href;
        return (
          <Link
            to={tab.href}
            key={tab.id}
            className={tw`
              font-bold text-xl flex items-center gap-x-2 p-2 focus:outline-none
              ${isActive ? "bg-primary text-white" : "text-[#5E5757]"}
            `}
          >
            {tab.icon} {tab.label}
          </Link>
        );
      })}
    </div>
  );
};

export default SwitchTab;
